var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stationId)?_c('v-card',{attrs:{"tile":""}},[_c('iframe',{attrs:{"src":_vm.siteMapLink,"width":_vm.width,"height":_vm.height}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }